import { render } from "./ButtonAnimation.vue?vue&type=template&id=38bf63f5&lang=pug"
import script from "./ButtonAnimation.vue?vue&type=script&lang=js"
export * from "./ButtonAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__